var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTaskIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2850112B-72CE-4EFE-A612-7FF096E75718") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-Dashboard",
    transform: "translate(-1140.000000, -139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "board",
    transform: "translate(1116.000000, 123.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8765957,0 L1.0893617,0 C0.487723847,0 0,0.487723847 0,1.0893617 L0,22.8765957 C0,23.4782336 0.487723847,23.9659574 1.0893617,23.9659574 L22.8765957,23.9659574 C23.4782336,23.9659574 23.9659574,23.4782336 23.9659574,22.8765957 L23.9659574,1.0893617 C23.9659574,0.487723847 23.4782336,0 22.8765957,0 Z M21.787234,21.787234 L2.1787234,21.787234 L2.1787234,2.1787234 L21.787234,2.1787234 L21.787234,21.787234 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53617021,18.5191489 C7.13780807,18.5191489 7.62553191,18.0314251 7.62553191,17.4297872 L7.62553191,9.80425532 C7.62553191,9.20261746 7.13780807,8.71489362 6.53617021,8.71489362 C5.93453236,8.71489362 5.44680851,9.20261746 5.44680851,9.80425532 L5.44680851,17.4297872 C5.44680851,18.0314251 5.93453236,18.5191489 6.53617021,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9829787,18.5191489 C12.5846166,18.5191489 13.0723404,18.0314251 13.0723404,17.4297872 L13.0723404,6.53617021 C13.0723404,5.93453236 12.5846166,5.44680851 11.9829787,5.44680851 C11.3813409,5.44680851 10.893617,5.93453236 10.893617,6.53617021 L10.893617,17.4297872 C10.893617,18.0314251 11.3813409,18.5191489 11.9829787,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4297872,18.5191489 C18.0314251,18.5191489 18.5191489,18.0314251 18.5191489,17.4297872 L18.5191489,9.80425532 C18.5191489,9.20261746 18.0314251,8.71489362 17.4297872,8.71489362 C16.8281494,8.71489362 16.3404255,9.20261746 16.3404255,9.80425532 L16.3404255,17.4297872 C16.3404255,18.0314251 16.8281494,18.5191489 17.4297872,18.5191489 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTaskIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/taskIcon.e1c858294e02b0ea01037fc4aa116d43.svg";